<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="560" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-text style="text-align: center; padding-top: 30px">
          <img
            height="100"
            width="100"
            :src="require('@/assets/img/networking.png')"
          />
          <br />
          <h2 class="pt-3">แก้ไขข้อมูล User Group</h2>
          <v-layout row wrap justify-center align-center pt-9>
            <v-flex xs10 sm10 md10 lg10>
              <v-autocomplete
                label="User Group"
                outlined
                dense
                :loading="LoadingItemsUserGroup"
                color="#077893"
                :items="ItemsUserGroup"
                :filter="customFilter"
                v-model="UserGroup"
                @click:clear="UserGroup = ''"
                append-icon="mdi-account-supervisor-outline"
                autocomplete
                ><template v-slot:no-data>
                  <div style="font-size: 12px" class="pa-4">
                    ไม่พบข้อมูลในระบบ
                  </div>
                  <v-divider></v-divider>
                  <v-list-item color="#077893" @click="fn_save()">
                    <v-list-item-icon
                      ><v-icon color="black">mdi-plus</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-left">
                        เพิ่ม User Group
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template></v-autocomplete
              >
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="justify-content: center" class="pb-5">
          <v-btn color="#077893" dark dense @click="fn_save()">
            {{ $t("smtp.text12") }}
          </v-btn>
          <v-btn color="red" text @click="close()">
            {{ $t("smtp.text11") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
// import { mapGetters } from 'vuex'
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_item"],
  data: function () {
    return {
      UserGroup: "",
      NewUserGroup: "",
      ItemsUserGroup: [],
      LoadingItemsUserGroup: true,
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogEdit");
        }
      },
    },
  },
  methods: {
    async fn_save() {
      var SelectUser = "";
      if (this.UserGroup) {
        SelectUser = this.UserGroup;
      } else if (this.NewUserGroup) {
        SelectUser = this.NewUserGroup;
      }
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        UserGroup: SelectUser,
        UserEmailId: this._item.UserEmailId,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/EditGroupEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loading = false;

          if (response.data.Status === "OK") {
            this.$emit("closeDialogEdit");
            this.$emit("reData");
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    async fn_getUSerGroup() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "email/GetGroupUserEmail",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.LoadingItemsUserGroup = false;
          if (response.data.Status === "OK") {
            this.ItemsUserGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.LoadingItemsUserGroup = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    customFilter(item, queryText, itemText) {
      this.NewUserGroup = "";
      this.NewUserGroup = queryText;
    },
    close() {
      this.$emit("closeDialogEdit");
    },
  },
  watch: {
    show(val) {
      if (val === true) {
        this.fn_getUSerGroup();
        this.UserGroup = this._item.UserGroup;
      }
    },
  },
};
</script>
